import { AutogenLayoutAccruedSettlementReport } from "./autogen/AutogenLayoutAccruedSettlementReport";

export class AccruedSettlementReport extends AutogenLayoutAccruedSettlementReport {
    override onLoad(): void {
        this.textboxPayeeType.selectedItem = this.textboxPayeeType.items[0];
    }
}
